import React, { Fragment, useState, useEffect } from 'react';
import { Container, Alert, Table } from 'react-bootstrap';
import RhService from '../../../../services/rh'
import Rh from './rh';
import FormBusca from './busca';
import '../../../../styles/diario.scss';
import { Navigate } from 'react-router-dom';

const RhsScreen = () => {

    const [rhs, setRhs] = useState([]);
    const [rhsOriginais, setRhsOriginais] = useState([]);
    const [editar, setEditar] = useState(false);
    const [senha, setSenha] = useState(false);
    const [vazio, setVazio] = useState(false);
    const [rh, setRh] = useState("");

    async function fetchRhs() {
        const response = await RhService.listar();
        if (response.data.length >= 1) {
            setRhs(response.data);
            setRhsOriginais(response.data);
            setVazio(false);
        } else {
            setRhs([]);
            setRhsOriginais([]);
            setVazio(true);
        }
    }

    const filtrarLocalmente = (nome) => {

        // Se todos vazios → voltar ao original
        if (!nome.trim()) {
            setRhs(rhsOriginais);
            setVazio(false);
            return;
        }

        const filtrados = rhsOriginais.filter(f => {
            const matchNome = nome.trim()
                ? f.rh.toLowerCase().includes(nome.toLowerCase())
                : true;
            return matchNome;
        });

        if (filtrados.length >= 1) {
            setRhs(filtrados);
            setVazio(false);
        } else {
            setRhs([]);
            setVazio(true);
        }
    };

    const handleEditar = (id) => {
        setRh(id);
        setEditar(true)
    }

     const handleSenha = (id) => {
        setRh(id);
        setSenha(true)
    }

    const deletar = async (id) => {
        if (window.confirm('Tem certeza que deseja excluir a usuária?')) {
            try {
                await RhService.deletar(id)
                alert("Usuária deletado com sucesso!")
                fetchRhs();
            } catch (err) {
                alert("Algo deu errado ao deletar a usuária!")
            }
        }
    }

    useEffect(() => {
        fetchRhs();
    }, []);

    if (editar) {
        return (
            <Navigate to={`/rh/rh/editar/${rh}`} />
        )
    } else if (senha) {
        return <Navigate to={`/rh/rh/senha/${rh}`} />;
    } 
    else {
        return (
            <Fragment>
                <Container>
                    <Fragment>
                        <FormBusca
                            fetchRhs={fetchRhs}
                            filtrarLocalmente={filtrarLocalmente}
                        />
                    </Fragment>
                    {vazio ? <Fragment>
                        <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
                    </Fragment> :
                        <Fragment>
                            <br/>
                            <Table className="table table-bordered tabela-rh">
                                <thead>
                                    <tr>
                                        <th>Usuária</th>
                                        <th>Nível</th>
                                        <th>E-mail</th>
                                        <th>Editar</th>
                                        <th>Trocar Senha</th>
                                        <th>Excluir</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {rhs.map((rh, index) =>
                                        <Rh
                                            fetchRhs={fetchRhs}
                                            rh={rh}
                                            key={index}
                                            editar={handleEditar}
                                            senha={handleSenha}
                                            deletar={deletar}
                                        />
                                    )}
                                </tbody>
                            </Table>
                        </Fragment>}
                </Container>
            </Fragment>

        )
    }
}

export default RhsScreen;